<template>
    <section class="w-full relative mb-12" :class="{'bg-gravaasuperlightwarmgray': graybg }">
        <div class="flex flex-col md:items-stretch" :class="imageOnLeft ? 'md:flex-row-reverse' : 'md:flex-row'">
            <!-- Text area with overflow to allow proper centering -->
            <div class="w-full md:w-screen flex items-center" :class="imageOnLeft ? 'md:-ml-[45vw]' : 'md:-mr-[45vw]'">
                <!-- Contentwrapper centers normally, extending beyond parent if needed -->
                <div class="contentwrapper">
                    <!-- Text content takes 5 columns, positioned based on image side -->
                    <div class="col-span-10 md:col-span-5 md:pt-22" :class="imageOnLeft ? 'md:col-start-6' : ''">
                        <div v-html="cleanHtml(article.contenthtml)"/>
                        
                        <NuxtLink v-if="article.excerpthtml" :to="extractLink(article.excerpthtml)">
                            <UiRippleButton class="black" v-motion-slide-right :delay="1200">
                            {{ article.excerpt }}
                            </UiRippleButton>                
                        </NuxtLink>
                    </div>
                </div>
            </div>

            <!-- Image column - exactly 45vw -->
            <div class="w-full md:w-[45vw] md:shrink-0 mt-4 md:mt-0">
                <UiArticleImage :fit="'max'" v-if="article.image" :article="article" class="w-full  object-cover"
                    :sizes="'sm:609px md:1024px lg:1280px xl:1500'">
                    <div v-if="showcaption && article.altText" class="text-white bg-gravaablack/70 p-5 m-0 ">
                        {{ article.altText }}
                    </div>
                </UiArticleImage>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useBlogStore } from '@/stores/blogStore';
import { computed } from 'vue';

const blogStore = useBlogStore();

// Props
const props = defineProps({
    article: {
        type: Object,
        required: true
    },
    showcaption: {
        type: Boolean,
        default: false
    }
});

// Determine if image should be on the left based on article tags
const imageOnLeft = computed(() => {
    return blogStore.articleHasTag(props.article, 'ImagesToTheLeft');
});

const graybg = computed(() => {
    return blogStore.articleHasTag(props.article, 'Bgwarmgray');
});

const extractLink = (excerptHtml) => {
    const linkRegex = /href=["'](.*?)["']/;
    const match = excerptHtml.match(linkRegex);
    return match ? match[1] : '#';
};

const cleanHtml = (html) => {
  // Define allowed tags
  const allowedTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'strong', 'em', 'a', 'br'];

  // Remove meta tags explicitly
  html = html.replace(/<meta[^>]*>/gi, '');

  // Use regex to remove unwanted tags while keeping allowed ones
  const regex = /<\/?([a-z][a-z0-9]*)[^>]*>/gi;

  return html.replace(regex, (match, tag) => {
    return allowedTags.includes(tag.toLowerCase()) ? match : '';
  });
};

</script>

<style scoped>
 :deep(ul) {
  list-style-type: disc;
  margin-left: .5rem;
  padding-left: .5rem;
 }
</style>